import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import IconInfo from "@mui/icons-material/InfoOutlined";
import React from "react";

interface DocLinkTooltipProps {
  docUrl?: string;
  children: React.ReactNode;
  label?: string;
  tooltipContent?: React.ReactNode;
  // Shown under the label and link; ignored when tooltipContent replaces them.
  tooltipExtra?: React.ReactNode;
}

const DocLinkTooltip = (props: DocLinkTooltipProps) => {
  const { docUrl, children, label, tooltipContent, tooltipExtra } = props;

  const tooltipTitle = tooltipContent ?? (
    <>
      <Box component="span">
        {label && (
          <Typography variant="body2" component="span">
            {label}
          </Typography>
        )}
        {docUrl && (
          <Box
            component="a"
            href={docUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: "block",
              color: "inherit",
              textDecoration: "underline",
              marginTop: label ? 0.5 : 0,
            }}
          >
            {docUrl}
          </Box>
        )}
      </Box>
      {tooltipExtra}
    </>
  );

  return (
    <Box position="relative">
      <Tooltip
        title={tooltipTitle}
        placement="top"
        arrow
        slotProps={{
          tooltip: {
            sx: {
              pointerEvents: "auto",
              // Code examples in tooltipExtra need more than the default 300px.
              ...(tooltipExtra && {
                maxWidth: "min(640px, calc(100vw - 32px))",
              }),
            },
          },
        }}
      >
        <IconButton
          component={docUrl ? "a" : "button"}
          href={docUrl}
          target="_blank"
          rel="noopener noreferrer"
          size="small"
          sx={{ position: "absolute", top: 0, right: 0, zIndex: 1 }}
        >
          <IconInfo fontSize="small" sx={{ width: 14, height: 14 }} />
        </IconButton>
      </Tooltip>
      {children}
    </Box>
  );
};

export default React.memo(DocLinkTooltip);
